import React from 'react';
import { NavLink } from 'react-router-dom';
import { Menu } from 'antd';
import {
  PRIVACY_PAGE,
  ABOUT_PAGE,
  TERMS_PAGE,
  BLOG_PAGE,
} from 'settings/constant';

const navigations = [
  {
    label: <NavLink to={`${TERMS_PAGE}`}>Terms</NavLink>,
    key: 'terms',
  },
  {
    label: <NavLink to={`${ABOUT_PAGE}`}>About</NavLink>,
    key: 'about',
  },
  {
    label: <NavLink to={`${PRIVACY_PAGE}`}>Privacy</NavLink>,
    key: 'privacy',
  },
  {
    label: <NavLink to={`${BLOG_PAGE}`}>Blog</NavLink>,
    key: 'blog',
  },
];

const FooterMenu = () => {
  return <Menu items={navigations} />;
};

export default FooterMenu;
